import { render, staticRenderFns } from "./EditPlan.vue?vue&type=template&id=72b45e62"
import script from "./EditPlan.vue?vue&type=script&lang=js"
export * from "./EditPlan.vue?vue&type=script&lang=js"
import style0 from "./EditPlan.vue?vue&type=style&index=0&id=72b45e62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports